import type { RouterOutputs } from '@duke-hq/svc-api/admin';
import type { RESOURCE_STATUSES_TYPE } from '@duke-hq/shared-constants/resourceStatuses';
import type { StudentCourseEnrolmentStatus } from '@duke-hq/svc-api-db';
import type { AssessmentInRevision } from '@duke-hq/svc-api/lib/assessment/types';
import type { getStructuredUnitOfCompetencies } from '@duke-hq/svc-api/lib/enrolment/getStructuredUnitOfCompetencies';
import type React from 'react';

export interface CourseItemsStatusAccordionLabels {
  semester: (n: number) => string;
  lln: string;
  skillSetUnits: string;
  enrolled: string;
  notEnrolled: string;
  unit: string;
  releaseDate: string;
  status: string;
}

export const defaultLabels: CourseItemsStatusAccordionLabels = {
  semester: (n: number) => `Semester ${n}`,
  lln: 'Language, Literacy, and Numeracy',
  skillSetUnits: 'Skill set units',
  enrolled: 'Enrolled',
  notEnrolled: 'Not Enrolled',
  unit: 'Unit',
  releaseDate: 'Release date',
  status: 'Status',
};

export type UnitActionsProps = {
  enrolmentId: number;
  unitOfCompetencyId: string;
  previousItemDueDate: Date | string | null;
  enrolmentStatus: StudentCourseEnrolmentStatus;
  unitScheduleOverallStatus: RESOURCE_STATUSES_TYPE;
  isAccredited: boolean;
  isLLN: boolean;
};

export interface CourseEnrolmentComponentProps {
  courseEnrolment: Omit<
    NonNullable<RouterOutputs['enrolment']['byIdWithResourceStatus']>,
    'consultant'
  >;
  assessmentsInRevision?: AssessmentInRevision[];
  UnitActionsComponent?: React.ComponentType<UnitActionsProps>;
  labels?: Partial<CourseItemsStatusAccordionLabels>;
  /**
   * When provided, submitted assessment rows render as links to the returned
   * path (built from the submission id). Only wired up in the admin app.
   */
  getAssessmentLink?: (submissionId: number) => string;
}

export type ProcessedUnits = ReturnType<typeof getStructuredUnitOfCompetencies>;
export type ScheduleAdjustment =
  CourseEnrolmentComponentProps['courseEnrolment']['CourseEnrolmentScheduleAdjustments'][number];
